import Vue from 'vue'
import App from './App.vue'
import 'at-ui-style'
import AtUI from 'at-ui'
import VueI18n from 'vue-i18n'
import zhLocale from 'at-ui/dist/locale/zh-CN'

Vue.use(VueI18n)
Vue.use(AtUI)

const i18n = new VueI18n({
  locale: 'zh',
  fallbackLocale: 'zh',
  messages: {
    'zh': { ...zhLocale }
  }
})

// AtUI.i18n((key, value) => i18n.t(key, value))

new Vue({
  el: '#app',
  i18n,
  ...App
})


// WEBPACK FOOTER //
// ./src/main.js